/* Cervisana — JS mínimo, sin dependencias. */
(function () {
  'use strict';

  /* ---------- Hora de Madrid ---------- */
  function madridNow() {
    var fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hour: 'numeric', minute: 'numeric', second: 'numeric', weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', hour12: false });
    var o = {};
    fmt.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    var wdMap = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 };
    return { h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10), s: parseInt(o.second, 10), wd: wdMap[o.weekday], y: parseInt(o.year, 10), mo: parseInt(o.month, 10), d: parseInt(o.day, 10) };
  }
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  function fmtDate(d) {
    return new Intl.DateTimeFormat('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }).format(d).replace(/\./g, '').replace('sept', 'sep');
  }

  /* ---------- Barra superior: corte + contador ---------- */
  var bar = document.querySelector('[data-cutoff-bar]');
  if (bar) {
    var cutoff = parseInt(bar.getAttribute('data-cutoff'), 10) || 16;
    var copy = bar.querySelector('[data-cutoff-copy]');
    var timer = bar.querySelector('[data-cutoff-timer]');
    var tick = function () {
      try {
        var n = madridNow();
        var weekend = n.wd === 0 || n.wd === 6;
        var before = !weekend && n.h < cutoff;
        var text = weekend ? bar.getAttribute('data-weekend') : (before ? bar.getAttribute('data-before') : bar.getAttribute('data-after'));
        if (copy) copy.textContent = text.replace('[hora]', String(cutoff));
        if (timer) {
          if (before) {
            var left = cutoff * 3600 - (n.h * 3600 + n.m * 60 + n.s);
            var hh = Math.floor(left / 3600), mm = Math.floor((left % 3600) / 60), ss = left % 60;
            timer.textContent = (hh < 10 ? '0' : '') + hh + ':' + (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
            timer.hidden = false;
          } else { timer.hidden = true; }
        }
      } catch (e) {}
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Entrega estimada con fecha ---------- */
  var del = document.querySelector('[data-delivery]');
  if (del) {
    try {
      var n2 = madridNow();
      var cut = parseInt(del.getAttribute('data-cutoff'), 10) || 16;
      var tmin = parseInt(del.getAttribute('data-min'), 10) || 1;
      var tmax = parseInt(del.getAttribute('data-max'), 10) || 3;
      var today = new Date(n2.y, n2.mo - 1, n2.d);
      var weekend2 = n2.wd === 0 || n2.wd === 6;
      var shipsToday = !weekend2 && n2.h < cut;
      var ship = shipsToday ? today : addBusinessDays(today, 1);
      var a = addBusinessDays(ship, tmin), b = addBusinessDays(ship, tmax);
      var out = del.querySelector('[data-delivery-date]');
      if (out) out.textContent = fmtDate(a) + ' – ' + fmtDate(b);
      var cl = document.querySelector('[data-delivery-cutoff]');
      if (cl) {
        var t = weekend2 ? cl.getAttribute('data-weekend') : (shipsToday ? cl.getAttribute('data-before') : cl.getAttribute('data-after'));
        cl.textContent = t.replace('[hora]', String(cut));
      }
    } catch (e) {}
  }

  /* ---------- Galería ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = g.querySelectorAll('[data-gallery-dots] i');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    function setActive(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      slides.forEach(function (s, k) { var v = s.querySelector('video'); if (!v) return; if (k === i) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) setActive(slides.indexOf(e.target)); }); }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = parseInt(t.getAttribute('data-gallery-thumb'), 10); slides[i] && track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); setActive(i); }); });
  });

  /* ---------- Packs ---------- */
  var form = document.getElementById('cervisana-form');
  if (form) {
    var idInput = form.querySelector('[data-variant-input]');
    var qtyInput = form.querySelector('[data-quantity-input]');
    var cardLink = document.querySelector('[data-card-link]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var apply = function (r) {
      if (idInput) idInput.value = r.value;
      if (qtyInput) qtyInput.value = r.getAttribute('data-quantity') || '1';
      if (cardLink) cardLink.setAttribute('href', r.getAttribute('data-card-url'));
      if (stickyPrice) stickyPrice.textContent = r.getAttribute('data-price');
    };
    var radios = form.querySelectorAll('[data-offer]');
    radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) apply(r); }); if (r.checked) apply(r); });
  }

  /* ---------- Barra fija ---------- */
  var sticky = document.querySelector('[data-sticky]');
  var buybox = document.querySelector('[data-buybox]');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    var primary = document.querySelector('[data-primary-cta]');
    var opens = sticky.getAttribute('data-opens-form') === 'true';
    var targets = Array.prototype.slice.call(document.querySelectorAll('.btn--cod.btn--lg, #cod-app-slot'));
    if (!targets.length) targets = [buybox];
    var visibleSet = new Set();
    var io2 = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) visibleSet.add(e.target); else visibleSet.delete(e.target); }); sticky.hidden = visibleSet.size > 0; }, { threshold: 0.2 });
    targets.forEach(function (t) { io2.observe(t); });
    var cta = sticky.querySelector('[data-sticky-cta]');
    if (cta) cta.addEventListener('click', function (ev) { ev.preventDefault(); buybox.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (opens && primary && !primary.disabled) setTimeout(function () { primary.click(); }, 450); });
  }

  /* ---------- Menú móvil ---------- */
  var burger = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (burger && menu) {
    burger.addEventListener('click', function () { var open = burger.getAttribute('aria-expanded') === 'true'; burger.setAttribute('aria-expanded', String(!open)); menu.hidden = open; });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { burger.setAttribute('aria-expanded', 'false'); menu.hidden = true; }); });
  }

  /* ---------- Ventana: seguir mi pedido ---------- */
  var modal = document.querySelector('[data-track-modal]');
  if (modal && typeof modal.showModal === 'function') {
    document.querySelectorAll('[data-track-open]').forEach(function (a) { a.addEventListener('click', function (ev) { ev.preventDefault(); modal.showModal(); }); });
    modal.querySelectorAll('[data-track-close]').forEach(function (b) { b.addEventListener('click', function () { modal.close(); }); });
    modal.addEventListener('click', function (ev) { if (ev.target === modal) modal.close(); });
  }
  document.querySelectorAll('[data-track-form]').forEach(function (f) {
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var wa = f.getAttribute('data-wa');
      var order = (f.querySelector('[name=order]').value || '').trim();
      var phone = (f.querySelector('[name=phone]').value || '').trim();
      var msg = 'Hola, quiero saber el estado de mi pedido #' + order + ' (teléfono ' + phone + ').';
      if (wa) window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
    });
  });
})();
